import React, {useMemo} from 'react';

// services
import {UserConfigManager} from '../../shared/services/UserConfigManager';

// helpers
import {useTranslation} from 'react-i18next';
import {useScreenWidth} from '../../shared/hooks';
import {useTheme} from '@emotion/react';
import {getQuickLinks} from './helpers';
import {checkHasFeatureAccess} from '../../shared/helpers';

// components
import {PageTemplate} from '../../shared/components';
import {CardQuickLink} from './components';
import {SectionActiveLoans, SectionActiveSubscriptions} from './sections';

// styles
import {QuickLinksWrapper} from './DashboardPage-styles';

const DashboardPage = () => {
  const {t} = useTranslation();
  const screenWidth = useScreenWidth();
  const theme = useTheme();
  const userConfig = UserConfigManager.getConfig();

  const quickLinks = useMemo(
    () => getQuickLinks(userConfig, t),
    [t, userConfig],
  );

  /**
   * Render the quick links
   * Display the description in desktop view only
   */
  const renderQuickLinks = () => {
    const displayDescription = screenWidth > theme.screenBreakpoint.md.value;
    return (
      <QuickLinksWrapper>
        {quickLinks.map((quickLink) => (
          <CardQuickLink
            key={quickLink.href}
            quickLink={quickLink}
            displayDescription={displayDescription}
          />
        ))}
      </QuickLinksWrapper>
    );
  };

  return (
    <PageTemplate title={t('menu_item_dashboard')} showWarningBanner={true}>
      {renderQuickLinks()}
      {checkHasFeatureAccess(userConfig, 'subscriptions') && (
        <SectionActiveSubscriptions />
      )}
      {checkHasFeatureAccess(userConfig, 'loans') && <SectionActiveLoans />}
    </PageTemplate>
  );
};

export default DashboardPage;
